export default __webpack_public_path__ + "static/media/alerta.0254b8bd.gif";